export default __webpack_public_path__ + "static/media/7.7a7e7a8c.png";